import React from 'react';
import './Tel.scss';
import { Props } from './interfaces';
import clsx from 'clsx';

const Tel = ({ phone, tag = 'p', className = '' }: Props) => {
  return (
    <a
      className={clsx('telTo', className)}
      href={`tel:${phone}`}
      target="_blank"
      dangerouslySetInnerHTML={{ __html: `<${tag}>${phone}</${tag}>` }}
    ></a>
  );
};

export default Tel;
